export default __webpack_public_path__ + "static/media/46.596b50f7.png";